<div class="form-check">
  <input
    class="form-check-input"
    type="checkbox"
    [id]="id || formControlName"
    [formControl]="getFormControl()"
    [ngClass]="{
      'is-invalid': required && getFormControl().invalid && (getFormControl().dirty || getFormControl().touched)
    }"
    (change)="onCheckboxChange($event)"
  />
  <label class="" [for]="id || formControlName">
    <span *ngIf="innerHtmlLabel" [innerHTML]="innerHtmlLabel"></span>
    <span *ngIf="label">{{ label }}</span>
    <span class="required" *ngIf="required"> *</span>
    <!-- Invalid -->
    <div *ngIf="required && getFormControl().invalid && (getFormControl().dirty || getFormControl().touched)" class="invalid-feedback">
      <div *ngIf="getFormControl().hasError('required')">{{ formControlError || 'This field is required' }}</div>
    </div>
  </label>
</div>
